<a [href]="url" class="footer-link">
  <ng-content></ng-content>
</a>
